import { Box, Drawer, styled } from "@mui/material";
import React, { useCallback, memo } from "react";

const AnimatedDrawerContent = styled(Box)(({ theme }) => ({
  transition: "transform 1s ease-in-out",
}));

function DrawerGlobalComp({
  open,
  setOpen,
  children,
  anchor = "right",
  animatedWidth = 330,
  className = "",
}) {
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  console.log("rerender header ===== drawer");
  return (
    <Drawer
      open={open}
      anchor={anchor}
      onClose={handleClose}
      className={className}>
      <AnimatedDrawerContent
        sx={{ width: animatedWidth }}
        style={{
          transform: open ? "translateX(0)" : "translateX(100%)",
          height: "100%",
        }}>
        {children}
      </AnimatedDrawerContent>
    </Drawer>
  );
}

const arePropsEqual = (prevProps, nextProps) => {
  if (
    prevProps.open !== nextProps.open ||
    prevProps.anchor !== nextProps.anchor ||
    prevProps.animatedWidth !== nextProps.animatedWidth ||
    prevProps.className !== nextProps.className
  ) {
    return false;
  }

  return true;
};

export default memo(DrawerGlobalComp, arePropsEqual);
